import React, { Component, PropTypes } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { DragDropContext, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { ModalManager} from '../helpers/index';
import PageListModal from '../helpers/PageListModal';
import { addRow, importPage, rowSortable, addBlock } from '../actions/index';
import { ItemTypes } from './Constants';
import Row from './Row';
import { changeIdofBlock } from '../helpers/commonHelper';
import withDragDropContext from '../helpers/withDragDropContext';
import AddNewRowButton from './AddNewRowButton';
import deepcopy from 'deepcopy'

class Pagebuilder extends Component{
  renderRowWithDnd(){
    let showClass = 'sppb-blocks-can-drop-placeholder';

    if(this.props.isOver){
      showClass = showClass + ' sppb-block-placeholder-show';
    }
    return this.props.connectDropTarget(
      <div className="sp-pagebuilder-rows">
        <div className={showClass}></div>
      </div>
    )
  }
  render(){
    const page = this.props.state.pageBuilder;

    if (document.getElementById('jform_sptext') != null) {
      var pageFiled = document.getElementById('jform_sptext')
      pageFiled.value = JSON.stringify(page.present);
    } else if (document.getElementById('jform_attribs_sppagebuilder_content') != null) {
      var pageFiled = document.getElementById('jform_attribs_sppagebuilder_content')
      pageFiled.value = JSON.stringify(page.present);
    }

    let toolsStyle = {};
    if(page.present.length){
      toolsStyle.padding = '50px 0'
    }

    return (
      <div>
        {
          page.present.length
          ?
          page.present.map( (row, index) => {
            return (
              <Row
                key={row.id}
                id={row.id}
                index={index}
                moveRow={this.props.rowSortable}
                row={row} />
            )}
          )
          :
          this.renderRowWithDnd()
        }

        {
          !page.present.length &&
          <div className="sp-pagebuilder-blank-page-tools" style={toolsStyle}>
            <ul>

              <li>
                <AddNewRowButton />
              </li>

              <li>
                <a
                  className="sp-pagebuilder-btn sp-pagebuilder-btn-success sp-pagebuilder-btn-lg"
                  href="#"
                  onClick={(e)=>{
                    e.preventDefault();
                    document.getElementById('upload-file').click();
                  }}>
                  <span><i className="pbfont pbfont-import"></i> {Joomla.JText._("COM_SPPAGEBUILDER_IMPORT_PAGE_ALT")}</span>
                </a>
              </li>

              <li>
                <a
                  className="sp-pagebuilder-btn sp-pagebuilder-btn-warning sp-pagebuilder-btn-lg"
                  href="#"
                  onClick={ (e) => {
                    e.preventDefault();
                    ModalManager.open(
                      <PageListModal
                        importPage={this.props.importPage}
                        onRequestClose={() => true } />
                    )
                  }}>
                  <span><i className="pbfont pbfont-layout"></i> {Joomla.JText._("COM_SPPAGEBUILDER_PAGE_TEMPLATES")}</span>
                </a>
              </li>

            </ul>
          </div>
        }


      </div>
    )
  }
}

const mapStateToProps = ( state ) => {
  return {
    state: state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addBlockAsRow: ( rowIndex, rowData ) => {
      dispatch(addBlock(rowIndex, rowData))
    },
    rowSortable: ( dragIndex, hoverIndex ) => {
      dispatch(rowSortable(dragIndex,hoverIndex))
    },
    addNewRow: () => {
      dispatch(addRow())
    },
    importPage: ( page ) => {
      dispatch(importPage(page))
    }
  }
}

const rowTarget = {
  hover(props, monitor, component) {
    const dragItem = monitor.getItem();

    if(dragItem.type == 'block'){
      let element = findDOMNode(component);
      element.classList.add('sppb-block-can-drag');
    }

  },
  drop(props, monitor, component){
    const item = monitor.getItem();

    if(item.type == 'block'){
      let blockData
      if (typeof item.element.section == 'string') {
        blockData = JSON.parse(item.element.section)
      } else {
        blockData = item.element.section
      }

      let newBlockData = changeIdofBlock(deepcopy(blockData))

      props.addBlockAsRow(props.index, newBlockData);

      let element = findDOMNode(component);

      element.classList.remove('sppb-block-can-drag');
    }
  }
};

var DropTargetDecorator = DropTarget([ItemTypes.ROW, ItemTypes.BLOCK], rowTarget,
  function(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    };
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withDragDropContext(DropTargetDecorator(Pagebuilder)));



// WEBPACK FOOTER //
// ./src/components/Pagebuilder.js